import { useContext } from 'react'
import { getRequest } from '../../../../services/base'
import { downloadErrorLogs } from '../../../../utils/common'
import { NavContext } from '../../../../context/global_context'
import Button from '../../../common/Button'

const DownloadDeleteFileLogBtn = ({ isBtn = false, vehicle }) => {
  const [navState, navDispatch] = useContext(NavContext)

  const downloadDeletedLogs = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Downloading Deleted files log ...',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/delete/promoted-files/download/?vehicle=${vehicle}`
    )
    if (res?.status) {
      if (res?.data?.file_data?.length > 0) {
        downloadErrorLogs(
          res.data.file_data,
          `${res?.data.branch_name}-${vehicle}-delete.log`
        )
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Files Successfully Downloaded',
          },
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'info',
            msg: 'Files Is Empty',
          },
        })
      }
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: 'Something went wrong!',
        },
      })
    }
  }

  return isBtn ? (
    <div className="flex justify-end items-center">
      <Button
        type="submit"
        className={`cursor-pointer btn`}
        text={'Download Deleted Logs'}
        onClick={() => {
          downloadDeletedLogs()
        }}
      />
    </div>
  ) : (
    <div
      className="underline cursor-pointer"
      onClick={() => {
        downloadDeletedLogs()
      }}
    >
      Download Deleted Logs
    </div>
  )
}

export default DownloadDeleteFileLogBtn
